import {useEventListener} from "@vueuse/core";
import {RouterNames} from "@/router/routerNames.ts";
import {push} from "notivue";
import router from "@/router";
import ObjectChecker from "@/utils/ObjectChecker.ts";

export class ShortcutUtils {
  static map: Map<RouterNames, () => Promise<void>> = new Map();

  static registerGlobalShortcuts() {
    this.registerKeyboardShortcuts();
  }

  private static registerKeyboardShortcuts() {
    useEventListener("keydown", async function (event) {
      const keyWord = "key"
      const code = event.code?.toLowerCase();
      if (code && event.ctrlKey && code == keyWord + 's') {
        event.preventDefault();
        await ShortcutUtils.saveEditing();
      }
    })
  }

  private static async saveEditing() {
    let key = router.currentRoute?.value?.name as RouterNames;
    const save = this.map.get(key)
    if (ObjectChecker.isEmptyOrNull(save)) {
      push.warning({
        title: "لا يوجد شي لحفظه هنا!"
      })
      return;
    }
    await save();
  }

  static addSaveChanges(routeName: RouterNames, saveChanges: () => Promise<void>) {
    this.map.set(routeName, saveChanges);
  }
}

